import { combineReducers } from 'redux';

import { FAILURE_RETAGGAGE, RECEIVE_RETAGGAGE, REQUEST_RETAGGAGE } from './constants';
import {
    REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
    RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
    FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT
} from '../discount/constants';

/***
 State shape
 {
    urlRewritten: string,
    fetching: boolean,
    error: string
 }
***/

const urlRewritten = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_RETAGGAGE:
            return action.response.payload.urlRewritten;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_RETAGGAGE:
            return true;
        case FAILURE_RETAGGAGE:
        case RECEIVE_RETAGGAGE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_RETAGGAGE:
            return action.response.message;
        case REQUEST_RETAGGAGE:
        case RECEIVE_RETAGGAGE:
            return '';
        default:
            return state;
    }
};

const discount = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
            return action.response.payload;
        default:
            return state;
    }
};

const discountFetching = (state = '', action) => {
    switch (action.type) {
        case REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
            return true;
        case RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
        case FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
            return false;
        default:
            return state;
    }
};

const discountError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
            return action.response.message;
        case REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
        case RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    urlRewritten,
    fetching,
    error,
    discount,
    discountFetching,
    discountError
});



// WEBPACK FOOTER //
// ./src/services/interstitiel/reducer.js